import { LoadIndicator } from "devextreme-react";

const LoadingIndicator = () => {
  return (
    <div className="grid place-items-center ">
      <LoadIndicator id="small-indicator" height={48} width={48} />
    </div>
  );
};

export default LoadingIndicator;
